<template>
  <div id="mid-swiper">
    <nav>
      <ul>
        <li v-for="(item, index) in navList" :key="index">
          <a :href="item.url" :title="item.title">{{item.title}}</a>
            <div class="clear" v-if="index == secNavIndex">
              <slot></slot>
            </div>
        </li>
      </ul>
    </nav>
    <ad-model :adCode="adCode"></ad-model>
  </div>
</template>

<script>
import AdModel from './AdModel'
export default {
  name: 'midswiper',
  components: {
    AdModel
  },
  props: ['navList', 'adCode', 'secNavIndex']
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
#mid-swiper >>> div
  #outer
    width: 750px !important
    height: 348px !important
    margin: 10px 0 0
    a
      img
        width: 100% !important
        height: 100% !important
#mid-swiper
  float: $fl
  width: 84%
  overflow hidden
  nav
    position: $rel
    border-bottom: 2px solid $mainNavBorderColor
    ul
      overflow: hidden
      li
        float: $fl
        div
          background: #edf8f6
          position: absolute
          top: 40px
          display: none
          z-index: 2
          a
            float: left
            padding: 2px 18px
            font-size: 14px
            color: #31a893
            &:hover
              background: #e2f5f1
        a
          padding: 0 30px
          font-size: 18px
          display: block
          color: $faultcolor
          height: 40px
          line-height: 40px
        &:hover
          background: #edf6f4
          a
            color: $themeColor
        &:hover
          div
            display :block

  .activity
    position: $abs
    right: 0
    top: -40px
    z-index: 1
</style>



// WEBPACK FOOTER //
// src/common-components/Channelmidswiper.vue